import { createStore } from 'vuex'

// Modules principaux
import { auth } from './auth.module';
import { globalstore } from './global.module';
import { user } from './modules/users';
import { parametrageCfas } from "./params.cfa";
import { branding } from './modules/branding';

// Modules des étudiants
import { etudiant } from "./modules/etudiant";
import { entretiens } from './modules/entretiens';
import { etudiantPlanIndividuelFormation } from "./modules/EtudiantPlanIndividuelFormation";
import { etudiantAbsences } from "@/store/modules/etudiantAbsences";
import { etudiantPointages } from "./modules/etudiantPointages";
import { etudiantGrilleMotivation } from "./modules/etudiantGrilleMotivation";
import { etudiantFacture } from "@/store/modules/etudiantFacture";
import { groupes } from "@/store/modules/groupes";
import { etudiantEntretiensSuivi } from "./modules/etudiantEntretiensSuivi"
import { etudiantSessions } from './modules/etudiantSessions'
import { etudiantContrat} from "@/store/etudiantContrat";
import { demandeInscription} from "@/store/modules/demandeInscription";
import { etudiantSuivis} from "@/store/modules/etudiantSuivis";
import { etudiantHistoriqueEntreprise} from "@/store/modules/etudiantHistoriqueEntreprise";
import {coordonneeUrgence} from "@/store/modules/etudiantCoordonneeUrgence";

// Modules Statistiques
import {statistiques_store} from "./modules/statistiques/store";

// Modules des antennes
import { antennePedagogieDocuments } from "./modules/antennePedagogieDocuments";
import { antenneDiplomeSessions } from "./modules/antenneDiplomeSessions";
import { antenneEvaluations } from "./modules/antenneEvaluations";
import { antenneConvention } from "./modules/antenneConvention";
import { antenneSequenceGroup} from "./modules/groupeSequences";
import { antennereferentiels } from "./modules/referentiels";
import { antenneSequence } from "./modules/antenneSequences";
import { antennediplome } from './modules/antennediplome';
import { antenneAlertes } from "./modules/alertes";
import { antenneActions } from "./modules/antenneActions"
import { dashboard } from "@/store/modules/dashboard";
import { antenneNotifications } from './modules/antenneNotifications'
import { antennesFermeture } from "@/store/modules/antennesFermeture";
import { antenneDiplomeSessionDetails } from "./modules/antenneDiplomeSessionDetails";
import { antenneInscription } from "./modules/antenneInscription";
import { antenneSecteurHoraires } from "./modules/antenneSecteurHoraires";

// Modules des documents
import { prestataireDocuments } from "./modules/prestataireDocuments";
import { entrepriseDocuments } from "./modules/entrepriseDocuments";
import { modeleDocuments } from "./modules/modeleDocuments";
import { documents } from "./modules/documents";
import { modeles } from "./modules/modeles";
import { dossiers } from "@/store/modules/dossiers";

// Modules des entreprises
import { entreprises } from "./modules/entreprises";
import { entrepriseSuivis } from './modules/entrepriseSuivis';
import { entrepriseContacts } from './modules/entrepriseContacts';
import { entrepriseTaxes } from './modules/entrepriseTaxes';

// Modules de gestion des événements
import { schedulerEventEmargements } from "./modules/SchedulerEventEmargements";
import { schedulerActivities } from "./modules/schedulerActivities";
import { schedulerClassrooms } from "./modules/schedulerClassrooms.js";
import { schedulerEquipments } from "./modules/schedulerEquipments";
import { schedulerActivityModules } from "./modules/schedulerActivityModules";
import { schedulerSpeakers } from "./modules/schedulerSpeakers";
import { schedulerEvents } from "./modules/schedulerEvents";
import { schedulerDayOffs } from "./modules/schedulerDayOffs";
import { schedulerOptions } from "./modules/schedulerOptions";
import { schedulerTimeslots } from "./modules/schedulerTimeslots.js";
import { SchedulerEventEmargementEtudiants } from "./modules/SchedulerEventEmargementEtudiants";
import { sessions } from "./modules/sessions";

//Modules pédagogie:
import {bilanParcours} from './modules/bilanParcours';
import {suiviRpp} from './modules/suiviRpp';
import { etudiantAca } from './modules/etudiantAca';

// Autres modules
import { prestataires } from "./modules/prestataires";
import { userAlertes } from "./modules/userAlertes";
import { apiSirene } from './modules/apiSirene';
import { apiMarcheInclusion } from './modules/apiMarcheInclusion';
import { assistance} from "@/store/modules/assistance";

//API Externe
import { apiGoogle } from './modules/apiGoogle'

export default function (/* { ssrContext } */) {
  const store = createStore({
    modules: {
      auth,
      globalstore,
      user,
      parametrageCfas,
      branding,
      etudiant,
      etudiantPlanIndividuelFormation,
      etudiantAbsences,
      etudiantPointages,
      etudiantSuivis,
      antennePedagogieDocuments,
      antenneDiplomeSessions,
      antenneEvaluations,
      antenneConvention,
      antenneSequenceGroup,
      antennereferentiels,
      antenneSequence,
      antennediplome,
      antenneAlertes,
      prestataireDocuments,
      entrepriseDocuments,
      modeleDocuments,
      documents,
      entreprises,
      entrepriseSuivis,
      entrepriseContacts,
      entrepriseTaxes,
      schedulerEventEmargements,
      SchedulerEventEmargementEtudiants,
      schedulerActivities,
      schedulerClassrooms,
      schedulerEquipments,
      schedulerActivityModules,
      schedulerSpeakers,
      schedulerEvents,
      schedulerDayOffs,
      schedulerOptions,
      schedulerTimeslots,
      sessions,
      prestataires,
      userAlertes,
      apiSirene,
      apiMarcheInclusion,
      modeles,
      antenneActions,
      etudiantGrilleMotivation,
      etudiantFacture,
      dossiers,
      dashboard,
      groupes,
      etudiantEntretiensSuivi,
      etudiantSessions,
      assistance,
      antenneNotifications,
      antennesFermeture,
      etudiantContrat,
      demandeInscription,
      entretiens,
      bilanParcours,
      suiviRpp,
      statistiques_store,
      apiGoogle,
      etudiantAca,
      antenneDiplomeSessionDetails,
      antenneInscription,
      antenneSecteurHoraires,
      coordonneeUrgence,
      etudiantHistoriqueEntreprise
    }
  })

  return store
}
